import Vue from 'vue';
window.Vue = Vue;

if (import.meta.env.DEV) {
    Vue.config.devtools = true;
}

import Sortable from 'sortablejs';

import Dialog from './plugins/dialog/js/index.js';
import Toast from './plugins/toast/js/index.js';
import VueScrollTo from 'vue-scrollto';

import DirtyForm from './dirty-form.js';
import { scrollToError } from './helpers.js';

import Toaster from './components/Toaster.vue';
import AvatarImg from './components/AvatarImg.vue';
import Files from './components/Files.vue';
import PricingPlanList from './components/PricingPlanList.vue';
import PublishButton from './components/PublishButton.vue';
import FormWizard from './components/FormWizard.vue';
import WizardStep from './components/WizardStep.vue';
import ProgressDonut from './components/ProgressDonut.vue';
import UploadProgressDonut from './components/UploadProgressDonut.vue';
import Tips from './components/Tips.vue';
import Modules from './components/Modules.vue';
import Lessons from './components/Lessons.vue';
import QuizResults from './components/members/QuizResults.vue';
import LessonsPage from './components/LessonsPage.vue';
import TriggerButton from './components/TriggerButton.vue';
import LessonFiles from './components/LessonFiles.vue';
import Page from './components/Page.vue';
import Tags from './components/Tags.vue';
import ActionToggle from './components/ActionToggle.vue';
import Clipboard from './components/Clipboard.vue';
import LessonPublish from './components/LessonPublish.vue';
import Members from './components/Members.vue';
import Transactions from './components/Transactions.vue';
import MembersImportList from './components/MembersImportList.vue';
import MembersImportCsvUpload from './components/MembersImportCsvUpload.vue';
import SaveButton from './components/SaveButton.vue';
import Toggled from './components/Toggled.vue';
import MultiToggled from './components/MultiToggled.vue';
import CourseProgress from './components/CourseProgress.vue';
import ApiKeys from './components/ApiKeys.vue';
import WebsiteSwitcherMenu from './components/WebsiteSwitcherMenu.vue';
import Subscriptions from './components/subscriptions/Subscriptions.vue';
import PageBuilder from './components/page-builder/PageBuilder.vue';
import SalesPageContent from './components/page-builder/SalesPageContent.vue';
import Block from './components/fields/Block.vue';
import Bullets from './components/fields/Bullets.vue';
import RteBullets from './components/fields/RteBullets.vue';
import ColorPicker from './components/fields/ColorPicker.vue';
import Dropdown from './components/fields/Dropdown.vue';
import DropdownEnablerField from './components/fields/DropdownEnablerField.vue';
import RedirectLocationDropdown from './components/fields/RedirectLocationDropdown.vue';
import Faqs from './components/fields/Faqs.vue';
import FileUpload from './components/fields/FileUpload.vue';
import ImageCheckbox from './components/fields/ImageCheckbox.vue';
import ImageUpload from './components/fields/image/ImageUpload.vue';
import ImageUploadWithCropper from './components/fields/image/ImageUploadWithCropper.vue';
import SmallImageUpload from './components/fields/image/SmallImageUpload.vue';
import PricingPlan from './components/fields/PricingPlan.vue';
import RichTextEditor from './components/fields/RichTextEditor.vue';
import Slug from './components/fields/Slug.vue';
import SubdomainField from './components/fields/SubdomainField.vue';
import Testimonials from './components/fields/Testimonials.vue';
import TitleAndSlug from './components/fields/TitleAndSlug.vue';
import Typography from './components/fields/Typography.vue';
import AudioUpload from './components/fields/AudioUpload.vue';
import VideoUpload from './components/fields/VideoUpload.vue';
import VideoWithThumbnailUpload from './components/fields/VideoWithThumbnailUpload.vue';
import Author from './components/fields/Author.vue';
import Toggle from './components/fields/Toggle.vue';
import TextLogoToggle from './components/fields/TextLogoToggle.vue';
import TagsField from './components/fields/Tags.vue';
import NumberSpinner from './components/fields/NumberSpinner.vue';
import Expandable from './components/fields/Expandable.vue';
import ToggleSlot from './components/fields/ToggleSlot.vue';
import SubmitBar from './components/fields/SubmitBar.vue';
import InputWithVars from './components/fields/InputWithVars.vue';
import CelebrationPreview from './components/fields/CelebrationPreview.vue';
import AutoComplete from './components/fields/AutoComplete.vue';
import DefaultHeader from './components/fields/DefaultHeader.vue';
import PageHeaderImage from './components/fields/PageHeaderImage.vue';
import Duration from './components/fields/Duration.vue';
import LimitedInput from './components/fields/LimitedInput.vue';
import LimitedTextarea from './components/fields/LimitedTextarea.vue';
import DomainVerificationInput from './components/fields/DomainVerificationInput.vue';
import TranscriptionToolbar from './components/fields/TranscriptionToolbar.vue';
import NewModuleModal from './components/modals/NewModuleModal.vue';
import EditModuleModal from './components/modals/EditModuleModal.vue';
import NewPageModal from './components/modals/NewPageModal.vue';
import PricingPlanModal from './components/modals/PricingPlanModal.vue';
import FilesUploadModal from './components/modals/FilesUploadModal.vue';
import VideoPlayerModal from './components/modals/VideoPlayerModal.vue';
import BulkVideoUploadModal from './components/modals/BulkVideoUploadModal.vue';
import NewApiKeyModal from './components/modals/NewApiKeyModal.vue';
import PreviewModal from './components/modals/PreviewModal.vue';
import ShowHide from './components/helpers/ShowHide.vue';
import IntegrationsModal from './components/integrations/IntegrationsModal.vue';
import OtherIntegrations from './components/integrations/other/Integrations.vue';
import CartIntegrationModal from './components/integrations/cart/NewIntegrationModal.vue';
import CartIntegrations from './components/integrations/cart/Integrations.vue';
import EmailIntegrations from './components/integrations/email/Integrations.vue';
import TrackingIntegrations from './components/integrations/tracking/Integrations.vue';
import Coupons from './components/coupons/List.vue';
import UsedCoupons from './components/coupons/Used.vue';
import AllComments from './components/comments/AllComments.vue';
import PostComments from './components/comments/PostComments.vue';
import MemberComments from './components/comments/MemberComments.vue';
import AddCommentModal from './components/comments/AddCommentModal.vue';
import ReplyToCommentModal from './components/comments/ReplyToCommentModal.vue';
import PageHeaderTabs from './components/PageHeaderTabs.vue';
import ShareProductModal from './components/products/ShareProductModal.vue';
import ProductLimitReachedModal from './components/plan-limits/ProductLimitReachedModal.vue';
import AdminLimitReachedModal from './components/plan-limits/AdminLimitReachedModal.vue';
import MemberLimitReachedModal from './components/plan-limits/MemberLimitReachedModal.vue';
import TrialImportRestrictedModal from './components/plan-limits/TrialImportRestrictedModal.vue';
import IconPicker from './components/fields/IconPicker.vue';
import WebsiteLimitReachedModal from './components/plan-limits/WebsiteLimitReachedModal.vue';
import ProductCategory from './components/fields/ProductCategory.vue';
import ProductCategories from './components/product-categories/ProductCategories.vue';
import ProductDripSchedule from './components/drips/ProductDripSchedule.vue';
import Memberships from './components/memberships/Memberships.vue';
import NewMembershipModal from './components/memberships/NewMembershipModal.vue';
import ShareMembershipModal from './components/memberships/ShareMembershipModal.vue';
import MemberMemberships from './components/members/MemberMemberships.vue';
import MembershipsRequiredModal from './components/members/MembershipsRequiredModal.vue';
import MembershipCartIntegrations from './components/integrations/cart/MembershipIntegrations.vue';
import MembershipEmailIntegrations from './components/integrations/email/MembershipIntegrations.vue';
import PromoOfferStatusButton from './components/promo-offers/PromoOfferStatusButton.vue';
import PromoOfferLocation from './components/promo-offers/PromoOfferLocation.vue';
import PromoOfferLink from './components/promo-offers/PromoOfferLink.vue';
import PromoOfferDates from './components/promo-offers/PromoOfferDates.vue';
import PromoOffers from './components/promo-offers/PromoOffers.vue';
import HelpButton from './components/HelpButton.vue';
import Blocklist from './components/Blocklist.vue';
import NewBlocklistRecordModal from './components/modals/NewBlocklistRecordModal.vue';
import EmailIdentityVerification from './components/settings/EmailIdentityVerification.vue';
import Leads from './components/Leads.vue';
import Posts from './components/posts/Posts.vue';
import MemberPosts from './components/posts/MemberPosts.vue';
import PostLikesList from './components/posts/PostLikesList.vue';
import Bumps from './components/bumps/Bumps.vue';
import Upsell from './components/upsell/Upsell.vue';
import DashboardStats from './components/widgets/DashboardStats.vue';
import Products from './components/products/Products.vue';
import ProductAddOns from './components/products/ProductAddOns.vue';
import NewProductModal from './components/products/NewProductModal.vue';
import MembershipProducts from './components/memberships/MembershipProducts.vue';
import MemberProducts from './components/members/MemberProducts.vue';
import PromoMembershipAndSalesPopup from './components/products/PromoMembershipAndSalesPopup.vue';
import SalesPopups from './components/sales-popups/SalesPopups.vue';
import SalesPopupModal from './components/sales-popups/SalesPopupModal.vue';
import QuizPublish from './components/QuizPublish.vue';
import QuizQuestions from './components/products/QuizQuestions.vue';
import QuizQuestionCard from './components/products/QuizQuestionCard.vue';

Vue.directive('sortable', {
    inserted: function (el, binding) {
        new Sortable(el, binding.value || {});
    }
});

Vue.use(Dialog);
Vue.use(Toast);
Vue.use(VueScrollTo);

Vue.filter('startCase', (value) => {
    return _.startCase(value);
});

Vue.filter('duration', (value) => {
    // Cleanup
    value = parseInt(value, 10);

    // Calculation
    let hours   = Math.floor(value / 3600);
    let minutes = Math.floor((value - (hours * 3600)) / 60);
    let seconds = value - (hours * 3600) - (minutes * 60);

    // Checks
    if (hours < 10) {
        hours = "0" + hours;
    }
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    if (seconds < 10) {
        seconds = "0" + seconds;
    }

    // Concatenation
    return hours + ':' + minutes + ':' + seconds;
});

Vue.directive('dirty', {
    inserted(element, binding) {
        new DirtyForm(element, binding.value || []);
    }
});

Vue.directive('scrollToError', {
    bind(element) {
        return scrollToError(element);
    }
});

Vue.directive('hover', {
    bind(element) {
        let mouseOverHandler = (event) => {
            // Clear old active step
            let activeCards = document.querySelectorAll('.card-hover.card-item-active');
            for (let i = 0; i < activeCards.length; i++) {
                activeCards[i].classList.remove('card-item-active');
            }

            element.classList.add('card-item-active');
        }

        element.addEventListener('mouseover', mouseOverHandler);
    }
});

Vue.directive('originalFallback', {
    bind(imageElement) {
        const replaceImgSrcWithOriginal = (event) => {
            event.target.src = event.target.src
                .replace('/max/', '/')
                .replace('/large/', '/')
                .replace('/small/', '/')
                .replace('/thumb/', '/');
        }

        imageElement.addEventListener('error', replaceImgSrcWithOriginal, {once: true});
    }
});

Vue.directive('gleapHelpArticle', {
    bind(element, binding) {
        const helpArticleId = binding.value;

        const helpArticleClickHandler = (event) => {
            event.preventDefault();

            if ( ! window.Gleap) {
                return;
            }

            if (helpArticleId) {
                window.Gleap.openHelpCenterArticle(helpArticleId, false);
            } else {
                window.Gleap.openHelpCenter(false);
            }
        }

        element.addEventListener('click', helpArticleClickHandler);
    }
});

Vue.directive('gleapNewConversation', {
    bind(element) {
        const newConversationClickHandler = (event) => {
            event.preventDefault();

            if ( ! window.Gleap) {
                return;
            }

            window.Gleap.startConversation();
        }

        element.addEventListener('click', newConversationClickHandler);
    }
});

Vue.directive('toggle', {
    bind(triggerElement, binding) {
        let triggerHandler = (event) => {
            let dropdownElement = document.getElementById(binding.value);
            let path = event.path || (event.composedPath ? event.composedPath() : undefined);

            if ((dropdownElement.offsetWidth || dropdownElement.offsetHeight)
            && path ? path.indexOf(triggerElement) < 0 : ! triggerElement.contains(event.target)) {
                dropdownElement.classList.remove('dropdown--toggled');
            } else {
                dropdownElement.classList.toggle('dropdown--toggled');
            }
        }

        let clickHandler = (event) => {
            let path = event.path || (event.composedPath ? event.composedPath() : undefined);

            if (path ? path.indexOf(triggerElement) < 0 : ! triggerElement.contains(event.target)) {
                document.getElementById(binding.value).classList.remove('dropdown--toggled');
            }
        }

        let escHandler = (event) => {
            if (event.keyCode === 27) {
                document.getElementById(binding.value).classList.remove('dropdown--toggled');
            }
        }

        let mouseOverHandler = (event) => {
            let dropdownElement = document.getElementById(binding.value);

            dropdownElement.classList.add('dropdown--toggled');
        }

        let mouseOutHandler = (event) => {
            let dropdownElement = document.getElementById(binding.value);

            dropdownElement.classList.remove('dropdown--toggled');
        }

        triggerElement.addEventListener('click', triggerHandler); // Useful for showing on touch devices
        triggerElement.addEventListener('mouseover', mouseOverHandler);
        triggerElement.addEventListener('mouseout', mouseOutHandler);
        document.documentElement.addEventListener('click', clickHandler, false); // This hides other toggled dropdowns
        window.addEventListener('keyup', escHandler, false);
    }
});

// Load components
Vue.component('toaster', Toaster);
Vue.component('avatar-img', AvatarImg);
Vue.component('files', Files);
Vue.component('pricing-plan-list', PricingPlanList);
Vue.component('publish-button', PublishButton);
Vue.component('form-wizard', FormWizard);
Vue.component('wizard-step', WizardStep);
Vue.component('progress-donut', ProgressDonut);
Vue.component('upload-progress-donut', UploadProgressDonut);
Vue.component('tips', Tips);
Vue.component('modules', Modules);
Vue.component('lessons', Lessons);
Vue.component('lessons-page', LessonsPage);
Vue.component('trigger-button', TriggerButton);
Vue.component('lesson-files', LessonFiles);
Vue.component('page', Page);
Vue.component('tags', Tags);
Vue.component('action-toggle', ActionToggle);
Vue.component('clipboard', Clipboard);
Vue.component('lesson-publish', LessonPublish);
Vue.component('quiz-publish', QuizPublish);
Vue.component('quiz-questions', QuizQuestions);
Vue.component('quiz-question-card', QuizQuestionCard);
Vue.component('members', Members);
Vue.component('transactions', Transactions);
Vue.component('members-import-list', MembersImportList);
Vue.component('members-import-csv-upload', MembersImportCsvUpload);
Vue.component('save-button', SaveButton);
Vue.component('toggled', Toggled);
Vue.component('multi-toggled', MultiToggled);
Vue.component('course-progress', CourseProgress);
Vue.component('api-keys', ApiKeys);
Vue.component('website-switcher-menu', WebsiteSwitcherMenu);
Vue.component('subscriptions', Subscriptions);

// Page builder
Vue.component('page-builder', PageBuilder);
Vue.component('sales-page-content', SalesPageContent);

// Load fields
Vue.component('block', Block);
Vue.component('bullets', Bullets);
Vue.component('rte-bullets', RteBullets);
Vue.component('color-picker', ColorPicker);
Vue.component('dropdown', Dropdown);
Vue.component('dropdown-enabler-field', DropdownEnablerField);
Vue.component('redirect-location-dropdown', RedirectLocationDropdown);
Vue.component('faqs', Faqs);
Vue.component('file-upload', FileUpload);
Vue.component('image-checkbox', ImageCheckbox);
Vue.component('image-upload', ImageUpload);
Vue.component('image-upload-with-cropper', ImageUploadWithCropper);
Vue.component('small-image-upload', SmallImageUpload);
Vue.component('pricing-plan', PricingPlan);
Vue.component('rich-text-editor', RichTextEditor);
Vue.component('slug', Slug);
Vue.component('subdomain-field', SubdomainField);
Vue.component('testimonials', Testimonials);
Vue.component('title-and-slug', TitleAndSlug);
Vue.component('typography', Typography);
Vue.component('audio-upload', AudioUpload);
Vue.component('video-upload', VideoUpload);
Vue.component('video-with-thumbnail-upload', VideoWithThumbnailUpload);
Vue.component('author', Author);
Vue.component('toggle', Toggle);
Vue.component('text-logo-toggle', TextLogoToggle);
Vue.component('tags-field', TagsField);
Vue.component('number-spinner', NumberSpinner);
Vue.component('expandable', Expandable);
Vue.component('toggle-slot', ToggleSlot);
Vue.component('submit-bar', SubmitBar);
Vue.component('input-with-vars', InputWithVars);
Vue.component('celebration-preview', CelebrationPreview);
Vue.component('autocomplete', AutoComplete);
Vue.component('default-header', DefaultHeader);
Vue.component('page-header-image', PageHeaderImage);
Vue.component('duration', Duration);
Vue.component('limited-input', LimitedInput);
Vue.component('limited-textarea', LimitedTextarea);
Vue.component('domain-verification-input', DomainVerificationInput);
Vue.component('transcription-toolbar', TranscriptionToolbar);

// Load modals
Vue.component('new-module-modal', NewModuleModal);
Vue.component('edit-module-modal', EditModuleModal);
Vue.component('new-page-modal', NewPageModal);
Vue.component('pricing-plan-modal', PricingPlanModal);
Vue.component('files-upload-modal', FilesUploadModal);
Vue.component('video-player-modal', VideoPlayerModal);
Vue.component('bulk-video-upload-modal', BulkVideoUploadModal);
Vue.component('new-api-key-modal', NewApiKeyModal);
Vue.component('preview-modal', PreviewModal);

// Helpers
Vue.component('show-hide', ShowHide);

// Integrations
Vue.component('integrations-modal', IntegrationsModal);
Vue.component('other-integrations', OtherIntegrations);

// Cart integrations
Vue.component('cart-integration-modal', CartIntegrationModal);
Vue.component('cart-integrations', CartIntegrations);

// Email integrations
Vue.component('email-integrations', EmailIntegrations);

// Tracking integrations
Vue.component('tracking-integrations', TrackingIntegrations);

// Coupons
Vue.component('coupons', Coupons);
Vue.component('used-coupons', UsedCoupons);

// Comments
Vue.component('all-comments', AllComments);
Vue.component('post-comments', PostComments);
Vue.component('member-comments', MemberComments);
Vue.component('add-comment-modal', AddCommentModal);
Vue.component('reply-to-comment-modal', ReplyToCommentModal);

// New MVP components
Vue.component('page-header-tabs', PageHeaderTabs);
Vue.component('share-product-modal', ShareProductModal);
Vue.component('product-limit-reached-modal', ProductLimitReachedModal);
Vue.component('admin-limit-reached-modal', AdminLimitReachedModal);
Vue.component('member-limit-reached-modal', MemberLimitReachedModal);
Vue.component('trial-import-restricted-modal', TrialImportRestrictedModal);
Vue.component('icon-picker', IconPicker);
Vue.component('website-limit-reached-modal', WebsiteLimitReachedModal);
Vue.component('product-category', ProductCategory);
Vue.component('product-categories', ProductCategories);
Vue.component('product-drip-schedule', ProductDripSchedule);
Vue.component('memberships', Memberships);
Vue.component('new-membership-modal', NewMembershipModal);
Vue.component('share-membership-modal', ShareMembershipModal);
Vue.component('member-memberships', MemberMemberships);
Vue.component('memberships-required-modal', MembershipsRequiredModal);
Vue.component('membership-cart-integrations', MembershipCartIntegrations);
Vue.component('membership-email-integrations', MembershipEmailIntegrations);
Vue.component('promo-offer-status-button', PromoOfferStatusButton);
Vue.component('promo-offer-location', PromoOfferLocation);
Vue.component('promo-offer-link', PromoOfferLink);
Vue.component('promo-offer-dates', PromoOfferDates);
Vue.component('promo-offers', PromoOffers);
Vue.component('help-button', HelpButton);
Vue.component('blocklist', Blocklist);
Vue.component('new-blocklist-record-modal', NewBlocklistRecordModal);
Vue.component('email-identity-verification', EmailIdentityVerification);
Vue.component('leads', Leads);

// Posts
Vue.component('posts', Posts);
Vue.component('member-posts', MemberPosts);
Vue.component('post-likes-list', PostLikesList);

// Bumps
Vue.component('bumps', Bumps);

// Upsell
Vue.component('upsell', Upsell);

// Stats
Vue.component('dashboard-stats', DashboardStats);

// Products
Vue.component('products', Products);
Vue.component('product-add-ons', ProductAddOns);
Vue.component('new-product-modal', NewProductModal);
Vue.component('membership-products', MembershipProducts);
Vue.component('member-products', MemberProducts);
Vue.component('quiz-results', QuizResults);

// Sales Popups
Vue.component('promo-membership-and-sales-popup', PromoMembershipAndSalesPopup);
Vue.component('sales-popups', SalesPopups);
Vue.component('sales-popup-modal', SalesPopupModal);
